import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { RegistrationDocument } from 'src/app/models/registration-document';
import { DocumentService, Utilities } from 'src/app/services';
import { ModalConfirmComponent } from '../../system/modal-confirm/modal-confirm.component';

@Component({
    selector: 'wm-renewal-document-list',
    templateUrl: './renewal-document-list.component.html',
    styleUrls: ['./renewal-document-list.component.css'],
    standalone: false
})
export class RenewalDocumentListComponent implements OnInit {
  @Input() documents: {
    id: string;
    documentName: string;
    documentPath: string;
    createdOn: string;
    createdBy: string;
    modifiedOn: string;
    modifiedBy: string;
    editing: boolean;
  }[];
  @Input() parentId: string;

  @Output() deleted: EventEmitter<any> = new EventEmitter<any>();
  @Output() added: EventEmitter<any> = new EventEmitter<any>();
  @Output() saved: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('deleteDocModal', { static: true }) deleteDocModal: ModalConfirmComponent;

  newDoc: boolean;
  newDocForm: UntypedFormGroup;
  newFiles = [];
  form: UntypedFormGroup;
  deleteDocumentId: string;

  commands: {
    title: string;
    idField: string;
    canPerform: (item: any) => boolean;
    handler: (id: string) => void;
  }[];

  constructor(
    private _fb: UntypedFormBuilder,
    public uploadService: DocumentService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.documents) {
      this.buildValidation();
    }
  }

  buildValidation() {
    if (!this.form) {
      this.form = this._fb.group({});
    }

    const ctls = this.form.controls;

    if (this.documents) {
      this.documents.forEach((d, i) => {
        if (!ctls[d.id]) {
          ctls[d.id] = this._fb.group({
            docName: [d.documentName, Validators.required]
          });
          ctls[d.id].disable();
        }
      });
    }

    this.form = this._fb.group(ctls);
  }
  ngOnInit() {
    this.newDocForm = this._fb.group({
      documentUploaded: ['', Validators.required]
    });

    this.commands = [
      {
        title: 'Delete',
        idField: 'id',
        canPerform: this.canDeleteDocument,
        handler: this.startDeleteDocument.bind(this)
      },
      {
        title: 'Edit',
        idField: 'id',
        canPerform: (e: any) => true,
        handler: this.editDocument.bind(this)
      }
    ];

    if (this.documents) {
      this.buildValidation();
    }
  }

  newDocStarted() {
    this.newDoc = true;
    this.newDocForm.reset();
    this.newFiles = [];
  }
  newDocumentsUploaded(files) {
    this.newFiles = files;
    this.newDocForm.controls.documentUploaded.setValue(true);
  }

  addDocuments() {
    // retrives uploaded documents and add them
    if ((this.newFiles || []).length > 0) {
      this.added.emit(this.newFiles);
    }
  }

  cancelEdit(item: RegistrationDocument) {
    item.editing = false;
  }
  editDocument(id: string) {
    const item: any = this.documents.find(d => d.id === id);

    if (item) {
      item.editing = true;
    }
    if (this.form.controls[id]) {
      this.form.controls[id].enable();
    }
  }

  saveDocument(item: RegistrationDocument) {
    item.editing = false;
    this.saved.emit(item);
  }

  canDeleteDocument(item: any): boolean {
    return true;
  }

  startDeleteDocument(id: string) {
    this.deleteDocumentId = id;
    this.deleteDocModal.open();
  }

  deleteDocument() {
    this.deleted.emit(this.deleteDocumentId);
  }

  cancelDocumentDelete() {
    this.deleteDocumentId = '';
  }

  canViewDocument(item: any): boolean {
    return true;
  }

  getDocPath(doc: RegistrationDocument): string {
    return Utilities.getAzureUrl(doc);
  }
  viewDocument(id: string) {
    const doc: any = this.documents.find(d => d.id === id);

    if (doc) {
      window.open(Utilities.getAzureUrl(doc), '_blank');
    }
  }
}
